<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title style="font-size: 16px;">
        {{ title }}
      </b-card-title>
      <!-- datepicker -->
      <div class="d-flex align-items-center">
        <b-button-group
          v-model="selectedRange"
          class="mt-1 mt-sm-0"
          buttons
        >
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-primary"
            :pressed="selectedRange === 'monthly'"
            value="monthly"
            @click="selectedRange = 'monthly'"
          >
            {{ $t('Last month') }}
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-primary"
            :pressed="selectedRange === 'yearly'"
            value="yearly"
            @click="selectedRange = 'yearly'"
          >
            {{ $t('Last year') }}
          </b-button>
        </b-button-group>
      </div>
      <!-- datepicker -->
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        :key="selectedRange"
        :height="400"
        :data="chartData"
        :options="chartOptions"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BButton, BButtonGroup, BCard, BCardHeader, BCardBody, BCardTitle,
} from 'bootstrap-vue'
import ChartjsComponentBarChart from '@/views/charts-and-maps/charts/chartjs/charts-components/ChartjsComponentBarChart.vue'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BButtonGroup,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    ChartjsComponentBarChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedRange: 'yearly',
    }
  },
  computed: {
    chartData() {
      return {
        labels: Object.keys(this.data[this.selectedRange]),
        datasets: [
          {
            data: Object.values(this.data[this.selectedRange]),
            backgroundColor: '#5AB78E',
            borderColor: 'transparent',
          },
        ],
      }
    },
    chartOptions() {
      return {
        elements: {
          rectangle: {
            borderWidth: 2,
            borderSkipped: 'bottom',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        legend: {
          display: false,
        },
        tooltips: {
          // Updated default tooltip UI
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 8,
          shadowColor: 'rgba(0, 0, 0, 0.25)',
          backgroundColor: $themeColors.light,
          titleFontColor: $themeColors.dark,
          bodyFontColor: $themeColors.dark,
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: true,
                color: 'rgba(200, 200, 200, 0.2)',
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
              },
              scaleLabel: {
                display: false,
              },
              ticks: {
                fontColor: '#6e6b7b',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                color: 'rgba(200, 200, 200, 0.2)',
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
              },
              ticks: {
                stepSize: Math.ceil(Math.max(...Object.values(this.data[this.selectedRange])) / 4),
                min: 0,
                max: Math.max(...Object.values(this.data[this.selectedRange])) + 2,
                fontColor: '#6e6b7b',
                callback(value) {
                  // Only show integers
                  if (Number.isInteger(value)) {
                    return value
                  }
                  return null
                },
              },
            },
          ],
        },
      }
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
